"use strict";
const { object, string } = require('../utils/modifiedYup');
const { durationSchema, MILLISECONDS_PER_MINUTE } = require('./durationSchema');
// Minimum duration is 1 minute
const MINIMUM_DURATION_MINUTES = 1;
const PROD_MINIMUM_DURATION_MILLSECONDS = MINIMUM_DURATION_MINUTES * MILLISECONDS_PER_MINUTE;
const ENGINE_INTEGRATION_TEST_MINIMUM_DURATION_MILLISECONDS = 100;
const MINIMUM_DURATION_MILLISECONDS = process.env.ENGINE_INTEGRATION_TESTING === 'true'
    ? ENGINE_INTEGRATION_TEST_MINIMUM_DURATION_MILLISECONDS
    : PROD_MINIMUM_DURATION_MILLSECONDS;
exports.timeSchema = object().shape({
    stepName: string().required().oneOf(['Wait']),
    delay: durationSchema
        .minimumDuration(MINIMUM_DURATION_MILLISECONDS)
        .required(),
});
//# sourceMappingURL=timeSchema.js.map